module.exports = __webpack_public_path__ + "img/pasaporte.2a29ce45.png";